<!--华普事件-->
<template>
	<div class="hpEventBody">
		<!--今日告警事件-->
		<div class="todayEvent" :style="backImg('/huapu/eventFrom.png')">
			<p class="hpTitle">今日告警事件</p>
			<div class="eventChild">
				<div class="flexCenter roundDiv">
					<img :src="imgName('/huapu/digital.png')">
					<span>{{todayCount}}</span>
				</div>
				<div class="eventList">
					<ul>
						<li v-for="item in todayCountList">
							<span>{{item.name}}</span>
							<div class="progressBar">
								<div :style="todayProgressBarCount(item)" style="height:100%;"></div>
							</div>
							<span>{{item.count}}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!--本月告警事件-->
		<div class="thisMonthEvent" :style="backImg('/huapu/eventFrom.png')">
			<p class="hpTitle">本月告警事件</p>
			<div class="eventChild">
				<div class="flexCenter roundDiv">
					<img :src="imgName('/huapu/digital.png')">
					<span>{{thisMonthCount}}</span>
				</div>
				<div class="eventList">
					<ul>
						<li v-for="item in thisMonthCountList">
							<span>{{item.name}}</span>
							<div class="progressBar">
								<div :style="thisMonthProgressBarCount(item)" style="height:100%;"></div>
							</div>
							<span>{{item.count}}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!--本月工单完成工作-->
		<div class="thisMonthOrder" :style="backImg('/huapu/eventFrom.png')">
			<p class="hpTitle">本月工单完成情况</p>
			<div class="eventChild">
				<div class="flexCenter roundDiv">
					<img :src="imgName('/huapu/digital.png')">
					<span>{{thisMonthOrder.inspectionOrder+thisMonthOrder.patrolOrder+thisMonthOrder.repairOrder}}</span>
				</div>
				<div class="eventList">
					<ul>
						<li>
							<span>巡检工单</span>
							<div style="width:30%;height:.1rem;background-color:#11b2fa;margin: 0 .1rem;"></div>
							<span>{{thisMonthOrder.inspectionOrder}}</span>
						</li>
						<li>
							<span>巡视工单</span>
							<div style="width:30%;height:.1rem;background-color:#20a564;margin: 0 .1rem;"></div>
							<span>{{thisMonthOrder.patrolOrder}}</span>
						</li>
						<li>
							<span>抢修工单</span>
							<div style="width:30%;height:.1rem;background-color:#7de061;margin: 0 .1rem;"></div>
							<span>{{thisMonthOrder.repairOrder}}</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!--今日工作-->
		<div class="todayWork">
			<div class="todayWorkChild flexCenterColumn" :style="backImg('/huapu/todayWork.png')">
				<p class="hpTitle" style="padding-left: 20px;width: calc(100% - 10px);">今日工作</p>
				<textarea v-model="unitInfo.texts" readonly="readonly" style="resize: none;">
				</textarea>
			</div>
			<div class="thisMonedefect" :style="backImg('/huapu/thisMonedefect.png')">
				<div class="workStar">
					<img v-for="item in 5" :src="imgNameStar(item)" />
				</div>
				<div class="defectText">
					<p>本月处理缺陷：<span>{{unitInfo.processedErrorCount}}</span></p>
					<p>本月发现缺陷：<span>{{unitInfo.findErrorCount}}</span></p>
					<p>缺陷处理率：<span>{{defectRate}}%</span></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {},
		props: {},
		data() {
			return {
				eventTypes: [],
				todayCountList: [],
				thisMonthCountList: [],
				todayCount: 0,
				thisMonthCount: 0,
				todayMax: 0,
				thisMonthMax: 0,
				unitInfo: {
					texts: '',
					processedErrorCount: '',
					findErrorCount: '',
					defectRate: ''
				},
				thisMonthOrder: {
					inspectionOrder: 0,
					patrolOrder: 0,
					repairOrder: 0,
				}
			}
		},
		created() {},
		mounted() {
			this.initData()
			this.getroundDiv()
			this.getUnitInfo()
		},
		destroyed() {},
		computed: {
			imgName() {
				return resourcesStore.getters.getResourcesByName
			},
			backImg() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			imgNameStar() {
				return index => {
					if (index * 20 > this.defectRate) {
						return this.imgName('huapu/star.png')
					} else {
						return this.imgName('huapu/starY.png')
					}
				}

			},
			todayProgressBarCount() {
				return item => {
					if (!isempty(item.count)) {
						var color = ''
						switch (item.name) {
							case '越限报警':
								color = '#11b2fa'
								break;
							case '变位报警':
								color = '#20a564'
								break;
							case '故障报警':
								color = '#7de061'
								break;
							case '用户操作':
								color = '#ffe14f'
								break;
							default:
								color = '#yellow'
								break;
						}
						if (item.count == 0 && this.todayMax == 0) {
							return {
								"width": "0%",
								"background-color": color
							}
						}
						return {
							"width": "{0}%".format((item.count / this.todayMax * 100).toFixed(2)),
							"background-color": color
						}
					}
				}
			},
			thisMonthProgressBarCount() {
				return item => {
					if (!isempty(item)) {
						var color = ''
						switch (item.name) {
							case '越限报警':
								color = '#11b2fa'
								break;
							case '变位报警':
								color = '#20a564'
								break;
							case '故障报警':
								color = '#7de061'
								break;
							case '用户操作':
								color = '#ffe14f'
								break;
							default:
								color = '#yellow'
								break;
						}
						if (item.count == 0 && this.thisMonthMax == 0) {
							return {
								"width": "0%",
								"background-color": color
							}
						}
						return {
							"width": "{0}%".format((item.count / this.thisMonthMax * 100).toFixed(2)),
							"background-color": color
						}
					}
				}
			},
			defectRate() {
				var value = (this.unitInfo.processedErrorCount / this.unitInfo.findErrorCount * 100).toFixed(2)
				return isNaN(value)?'':value
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
		},
		watch: {
			eventTypes(nv, ov) {
				this.getroundDiv()
			},
			nowUnit(nv, ov) {
				this.initData()
				this.getroundDiv()
				this.getUnitInfo()
			}
		},
		methods: {
			initData() {
				//获取事件类型
				this.$api.eventApi.searchAllEventTypes(respon => {
					if (!isempty(respon)) {
						this.eventTypes = respon
					}
				})
			},
			getroundDiv() {
				var typeNos = ''
				this.eventTypes.forEach((item, index) => {
					if (this.eventTypes.length == index + 1) {
						typeNos += item.no
					} else {
						typeNos += item.no + ','
					}
				})
				var today = new Date().format('yyyy-MM-dd')
				var thisMome = new Date().format('yyyy-MM')
				var startTime = new Date(today + ' 00:00:00').getTime()
				var endTime = new Date().getTime()
				this.todayCountList = copy(this.eventTypes)
				this.thisMonthCountList = copy(this.eventTypes)
				//获取今日事件汇总
				this.$api.eventApi.countEventListByUser('', this.nowUnit.id, typeNos, -1, '', '', startTime, endTime, '', respon => {
					this.todayCount = 0
					if (!isempty(respon)) {
						this.todayCountList.forEach(e => {
							if (!isempty(respon[e.no])) {
								e.count = respon[e.no]
								this.todayCount += respon[e.no]
								//筛选出事件中的最大值
								if (this.todayMax < respon[e.no]) {
									this.todayMax = respon[e.no]
								}
							} else {
								e.count = 0
							}
						})
					}
				})
				//获取本月事件汇总
				this.$api.eventApi.countEventListByUser('', this.nowUnit.id, typeNos, -1, '', '', new Date(thisMome +
					'-01 00:00:00').getTime(), endTime, '', respon => {
					this.thisMonthCount = 0
					if (!isempty(respon)) {
						this.thisMonthCountList.forEach(e => {
							if (!isempty(respon[e.no])) {
								e.count = respon[e.no]
								this.thisMonthCount += respon[e.no]
								if (this.thisMonthMax < respon[e.no]) {
									this.thisMonthMax = respon[e.no]
								}
							} else {
								e.count = 0
							}
						})
					}
				})
			},
			getUnitInfo() {
				var thisMome = new Date().format('yyyy-MM')
				this.unitInfo = {
						texts: '',
						processedErrorCount: '',
						findErrorCount: '',
						defectRate: ''
					},
					this.$api.unitApi.getUnitInfo(this.nowUnit.id, respon => {
						if (!isempty(respon)) {
							this.unitInfo = respon
						}
					})
				var beginTime = new Date(thisMome + '-01 00:00:00').getTime()
				var endTime = new Date().getTime()
				this.$api.orderApi.searchCountByType(undefined, '1,2,3', undefined, undefined, undefined, undefined, undefined, beginTime, endTime,undefined, respon => {
					if (!isempty(respon)) {
						this.thisMonthOrder.inspectionOrder = respon['1']
						this.thisMonthOrder.patrolOrder = respon['2']
						this.thisMonthOrder.repairOrder = respon['3']
					}
				})

			},
		}
	}
</script>

<style scoped>
	.hpEventBody {
		width: calc(100% - 20px);
		height: calc(100% - 20px);
		padding: 10px;
		display: flex;
		flex-flow: wrap;
		justify-content: space-around;
	}

	.todayEvent,
	.thisMonthEvent,
	.thisMonthOrder,
	.todayWork {
		background-repeat: no-repeat;
		background-size: 100% 100%;
		width: calc(50% - 5px);
		height: 50%;
	}

	p.hpTitle{
		font-size: 12px;
		color: white;
		padding-left: .1rem;
		padding-top: .1rem;
	}

	.todayWorkChild,
	.thisMonedefect {
		width: 100%;
		height: calc(50% - 5px);
	}

	.thisMonedefect {
		margin-top: 10px;
	}

	.hpEventBody span {
		color: white;
	}

	.eventList {
		width: 100%;
		height: 100%;
		overflow-y: overlay;
	}

	.eventList::-webkit-scrollbar {
		display: none
	}

	.eventList ul li {
		display: flex;
		align-items: center;
		padding-top: .1rem;
	}

	.eventList ul li span {
		font-size: 12px;
	}

	.thisMonthOrder .eventList ul li {
	}

	.eventChild {
		width: 100%;
		height: 70%;
		display: flex;
		align-items: center;
		margin-left: .1rem;
		margin-right: .1rem;
	}

	.roundDiv {
		width: 30%;
		height: 45%;
		position: relative;
	}

	.roundDiv img {
		height: 100%;
	}

	.roundDiv img,
	.roundDiv span {
		position: absolute;
	}

	.progressBar {
		width: 40%;
		background-color: #515A6E;
		height: .1rem;
		margin-left: .1rem;
		margin-right: .1rem;
	}

	.todayWorkChild textarea {
		width: calc(100% - 40px);
		height: calc(100% - 40px);
		margin: 10px 20px;
		background-color: rgba(0, 0, 0, 0);
		border: 0;
		color: white;
		outline: none;
	}

	.todayWorkChild textarea::-webkit-scrollbar {
		display: none
	}

	.defectText {
		width: 100%;
		height: 60%;
		overflow-y: overlay;
	}

	.defectText::-webkit-scrollbar {
		display: none
	}

	.defectText p {
		color: white;
		margin-left: .2rem;
		line-height: .2rem;
		font-size: 12px;
	}

	.workStar {
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.workStar img {
		width: .25rem;
	}
</style>
